export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const FULL_DAYS = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
];

const getDay = (index: number): string => DAYS[index];
const getMonth = (index: number): string => MONTHS[index];

const getFormattedMonth = (index: number): string =>
  index < 10 ? `0${index}` : `${index}`;

const nth = (d: number): string => {
  if (d > 3 && d < 21) return "th";
  switch (d % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

const getDDDMMM = (date: Date): string => {
  const day = getDay(date.getDay());
  const month = getMonth(date.getMonth());
  const dateIndex = date.getDate();

  return `${day} ${dateIndex} ${month}`;
};

const getDMMMYY = (date: Date): string => {
  const month = getMonth(date.getMonth());
  const dateIndex = date.getDate();
  const year = date
    .getFullYear()
    .toString()
    .substr(-2);

  return `${dateIndex}${nth(dateIndex)} ${month} '${year}`;
};

const getDMMMYYYY = (date: Date): string => {
  const month = getMonth(date.getMonth());
  const dateIndex = date.getDate();
  const year = date.getFullYear().toString();

  return `${dateIndex}${nth(dateIndex)} ${month}, ${year}`;
};

const getDDMMYYYYEEEE = (date: Date): string => {
  const month = getFormattedMonth(date.getMonth() + 1);
  const dateIndex = date.getDate();
  const year = date.getFullYear().toString();
  const day = FULL_DAYS[date.getDay()];

  return `${dateIndex}/${month}/${year}, ${day}`;
};

const getDDMMYYYY = (date: Date): string => {
  let month = (date.getMonth() + 1).toString();
  const dateIndex = date.getDate();
  const year = date.getFullYear().toString();

  if (parseInt(month) < 10) {
    month = `0${month}`;
  }

  return `${dateIndex}/${month}/${year}`;
};

export const formatDate = (date: string, format: string): string => {
  if (!date) {
    return "";
  }
  const newDate = new Date(date);
  const response = {
    DDDMMM: getDDDMMM(newDate),
    DMMMYY: getDMMMYY(newDate),
    DDMMYYYY: getDMMMYYYY(newDate),
    DDMMYYYYEEEE: getDDMMYYYYEEEE(newDate),
    "DD/MM/YYYY": getDDMMYYYY(newDate)
  };

  return (response as any)[format];
};

export enum DateFormats {
  FULL_DATE = "EEEE, MMMM d, yyyy",
  ISO_DATE = "yyyy-MM-dd"
}

export default formatDate;
